import "./LoadingComponent.css";
/*
Display a loading component

Props
display : boolean - Display or not
label : string - Text to display
isCover: boolean - Cover screen or not (default : true)
*/
const LoadingComponent = (props) => {


  if (!props.display)
    return null;

  //

  return (
    <div className="loadingcomponent_cont" style={{ backgroundColor: (props.isCover ? "rgba(255, 255, 255, 0.9)" : "transparent") }}>
      <div className="loadingcomponent_body">
        <div className="loadingcomponent_spinner" />
        {props.label}
      </div>
    </div>
  );

}

export default LoadingComponent;